const PROFILE = {
  PROFILES: '/profile'
}

export default PROFILE
